var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCl3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 128,
    viewBox: "0 0 240 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_729_1136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 48,
    width: 38,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 48H101.5V80H138.5V48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_729_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.066 50.4064C131.227 50.4064 133.791 63.5955 133.791 79.884H138.404C138.404 62.3477 133.75 48.1523 128.052 48.1523C124.796 48.1523 121.919 52.4056 120.02 59.0873C118.12 52.4056 115.244 48.1523 112.015 48.1523C106.316 48.1523 101.676 62.3343 101.676 79.8706H106.289C106.289 63.5821 108.826 50.4064 111.987 50.4064C115.149 50.4064 117.713 62.5892 117.713 77.6165H122.299C122.299 62.5892 124.877 50.4064 128.038 50.4064",
    fill: "#2A3342"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl3);
export default __webpack_public_path__ + "static/media/cl3.e78aefae65ddc88101d3d3c0217708d3.svg";
export { ForwardRef as ReactComponent };